'use strict';

var Reflux = require('reflux');

/* Stores */
var ModuleTypeStore = require('./module-type');
var ProjectStore = require('./project');

/* Actions */
var ModuleActions = require('actions/module');
var ModuleConnectionActions = require('actions/module-connection');
var ProjectActions = require('actions/project');

/* Api */
var ModuleApi = require('api/module');

var ModuleStore = Reflux.createStore({

  listenables: [ModuleActions],

  init: function init() {
    var store = this;

    store.modules = [];
    store.shouldLoadModulesForProject = null;

    store.listenTo(ProjectActions.addModule, 'onAddModule');
    store.listenTo(ProjectActions.leave, 'onLeaveProject');
    store.listenTo(ModuleTypeStore, 'onModuleTypeStoreChange');
    store.listenTo(ModuleConnectionActions.selectConnection, 'onSelectConnection');
  },

  getInitialState: function getInitialState() {
    var store = this;
    return store.modules;
  },

  onSelectModule: function onSelectModule(moduleId, modifiers) {
    var store = this;
    var modules = store.modules;

    var selectMultiple = modifiers.metaKey || modifiers.ctrlKey;

    modules.forEach(function (module) {
      var match = module.id === moduleId;

      if (selectMultiple) {
        if (match) {
          module.selected = !module.selected;
        }
      } else {
        module.selected = match;
      }
    });

    store.trigger(modules);
  },

  onDeselectAllModules: function onDeselectAllModules() {
    var store = this;
    var modules = store.modules;

    modules.forEach(function (module) {
      module.selected = false;
    });

    store.trigger(modules);
  },

  onSelectConnection: function onSelectConnection() {
    var store = this;

    store.onDeselectAllModules();
  },

  onDeleteSelectedModules: function onDeleteSelectedModules() {
    var _this = this;

    var modules = this.modules;

    var selectedIds = modules.filter(function (module) {
      return module.selected;
    }).map(function (module) {
      return module.id;
    });

    if (!selectedIds.length) {
      return;
    }

    ModuleApi['delete'](selectedIds).done(function () {
      _this.modules = modules.filter(function (module) {
        return !module.selected;
      });
      _this.trigger(_this.modules);
    });
  },

  onStartDragging: function onStartDragging(moduleId, x, y) {
    var store = this;
    var modules = store.modules;

    var module = modules.find(function (module) {
      return module.id === moduleId;
    });

    store.drag = {
      module: module,
      offset: { x: x, y: y },
      original: Object.assign({}, module.position)
    };
    store.dragging = true;
    store.draggedModuleId = moduleId;

    store.trigger(modules);
  },

  onStopDragging: function onStopDragging() {
    var store = this;
    var drag = store.drag;
    var modules = store.modules;
    var module = drag.module;
    var original = drag.original;
    var id = module.id;
    var position = module.position;

    store.drag = null;
    store.dragging = false;
    store.draggedModuleId = null;

    store.trigger(modules);

    if (position.x !== original.x || position.y !== original.y) {
      ModuleApi.update(id, { position: position });
    }
  },

  onUpdateDrag: function onUpdateDrag(newOffsetX, newOffsetY) {
    var store = this;
    var drag = store.drag;
    var modules = store.modules;

    if (drag) {
      (function () {
        var module = drag.module;
        var original = drag.original;
        var offset = drag.offset;
        var _module2 = module;
        var position = _module2.position;

        var x = original.x + (newOffsetX - offset.x);
        var y = original.y + (newOffsetY - offset.y);

        modules.some(function (mod, index) {
          if (mod.id === module.id) {
            module = Object.assign(Object.assign({}, module), { position: { x: x, y: y } });
            modules[index] = module;
            return true;
          }
          return false;
        });

        drag.module = module;

        store.trigger(modules);
      })();
    }
  },

  find: function find(id) {
    var store = this;
    var modules = store.modules;

    return modules.find(function (module) {
      return module.id === id;
    });
  },

  onAddModule: function onAddModule(projectId, moduleTypeId, position) {
    var store = this;
    var modules = store.modules;
    var moduleTypes = ModuleTypeStore.moduleTypes;

    ModuleApi.add({ projectId: projectId, moduleTypeId: moduleTypeId, position: position }).done(function (data) {
      data.moduleType = moduleTypes.find(function (moduleType) {
        return moduleType.id === moduleTypeId;
      });

      modules.push(data);
      store.trigger(modules);
    });
  },

  onLoadModulesForProject: function onLoadModulesForProject(projectId) {
    var store = this;
    var moduleTypes = ModuleTypeStore.moduleTypes;
    var typesLoaded = ModuleTypeStore.typesLoaded;

    if (!typesLoaded) {
      store.shouldLoadModulesForProject = projectId;
      return;
    }

    store.modules = [];
    store.trigger(store.modules);

    ModuleApi.load({ projectId: projectId }).done(function (data) {

      data.forEach(function (module) {
        module.moduleType = moduleTypes.find(function (moduleType) {
          return moduleType.id === module.moduleType;
        });
      });

      store.modules = data;
      store.trigger(store.modules);
    });
  },

  onModuleTypeStoreChange: function onModuleTypeStoreChange(moduleTypes) {
    var store = this;

    var projectId = store.shouldLoadModulesForProject;
    if (projectId) {
      store.shouldLoadModulesForProject = null;
      store.onLoadModulesForProject(projectId);
    }
  },

  onLeaveProject: function onLeaveProject() {
    this.modules = [];
    this.trigger(this.modules);
  }

});

module.exports = ModuleStore;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/stores/module.js
 **/